<template>
  <div class="wrapper">
    <div class="top_contain">
      <img class="tanhao_inage" src="../../../../../assets/img/tanhao.png" alt="" />
      <div class="font_14_1890FF">
        <span class="font_14_333333">请配置当前角色在应用中数据及操作项的权限；</span
        >如果需要进行二次授权时，可选择的权限范围为此处配置的资源及操作项权限。
      </div>
    </div>
    <div style="width:100%">
      <div class="flex_column">
        <span class="padding_top_20">语音对讲</span>
        <div class="flex_row_center margin_bottom_30">
          <div class="flex_center_center">
            <el-checkbox v-model="logAddEnable" @change="checkBoxChange">自己所在群组</el-checkbox>
          </div>
          <div class="flex_center_center">
            <el-checkbox v-model="logDeleteEnable" @change="checkBoxChange">所有群组</el-checkbox>
          </div>
        </div>
        <span class="padding_top_20">视频查看</span>
        <div class="flex_row_center margin_bottom_30">
          <div class="flex_center_center">
            <el-checkbox v-model="videoScreenshot" @change="checkBoxChange"
              >自己所在群组</el-checkbox
            >
          </div>
          <div class="flex_center_center">
            <el-checkbox v-model="videoDleteScreenshot" @change="checkBoxChange"
              >所有群组</el-checkbox
            >
          </div>
        </div>
        <span class="padding_top_20">设备管理</span>
        <div class="flex_row_center">
          <div class="flex_center_center">
            <el-checkbox v-model="videoScreenshot" @change="checkBoxChange">创建群组</el-checkbox>
          </div>
          <div class="flex_center_center">
            <el-checkbox v-model="videoDleteScreenshot" @change="checkBoxChange"
              >添加设备</el-checkbox
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from '@/lib/axios';
import API from '@/lib/apiList';
export default {
  props: {
    roleId: String
  },
  data() {
    return {
      systermId: '',
      logAddEnable: false,
      logDeleteEnable: false,
      logDownEnable: false,
      videoScreenshot: false,
      videoDleteScreenshot: false
    };
  },
  mounted() {
    this.$emit('dataBoxChanged', {
      logAddEnable: this.logAddEnable,
      logDeleteEnable: this.logDeleteEnable,
      logDownEnable: this.logDownEnable,
      videoScreenshot: this.videoScreenshot,
      videoDleteScreenshot: this.videoDleteScreenshot
    });
  },
  created() {},
  watch: {
    roleId(value) {
      if (this.roleId.length > 0) {
        this.dataBoxRequest(value);
      }
    }
  },

  methods: {
    checkBoxChange() {
      this.$emit('dataBoxChanged', {
        logAddEnable: this.logAddEnable,
        logDeleteEnable: this.logDeleteEnable,
        logDownEnable: this.logDownEnable,
        videoScreenshot: this.videoScreenshot,
        videoDleteScreenshot: this.videoDleteScreenshot
      });
    },

    dataBoxRequest(roleId) {
      Axios.requestJson({
        url: '/workConstructionLog/queryRoleResource',
        data: {
          projectId: this.$cookies.get('PROJECT_ID'),
          roleId: roleId
        }
      })
        .then(res => {
          if (res.data.code == '1000') {
            let info = res.data.result;
            this.logAddEnable = Boolean(info.createUpdateData);
            this.logDeleteEnable = Boolean(info.delData);
            this.logDownEnable = Boolean(info.isDownloadData);
            this.videoScreenshot = Boolean(info.printScreen);
            this.videoDleteScreenshot = Boolean(info.delPrintscreen);

            this.$emit('dataBoxChanged', {
              logAddEnable: this.logAddEnable,
              logDeleteEnable: this.logDeleteEnable,
              logDownEnable: this.logDownEnable,
              videoScreenshot: this.videoScreenshot,
              videoDleteScreenshot: this.videoDleteScreenshot
            });
          } else {
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  }
};
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  background: white;
  padding-left: 0px;
  padding-right: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.top_contain {
  background: #eef7fe;
  padding-left: 17px;
  padding-right: 17px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #d5ebfd;
  margin-bottom: 19px;
  width: 100%;
}

.tanhao_inage {
  width: 18px;
  height: 18px;
}

.font_14_333333 {
  font-size: 14px;
  color: #333333;
}

.font_14_1890FF {
  font-size: 14px;
  color: #1890ff;
}

.flex_spaceBetween {
  width: 50%;
  padding-left: 30px;
  display: flex;
  height: 30px;
  justify-content: space-between;
  align-items: center;
}

.flex_end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.font_13_color_666666 {
  font-size: 13px;
  color: #666666;
}

.flex_column {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 20px;
}

.flex_row_center {
  display: flex;
  align-items: center;
}

.flex_center_center {
  display: flex;
  align-items: center;
  width: 200px;
}

.padding_top_20 {
  padding-top: 10px;
  padding-bottom: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 500;
}

.margin_bottom_30 {
  margin-bottom: 30px;
}
</style>
